import type { CSSProperties } from "react";
import { brandColorTokens } from "./brandColorTokens";
import classes from "./brandControls.module.css";
import selectClasses from "./brandSelectDropdown.module.css";

export const brandButtonHoverClassName = classes.brandButton;
export function brandButtonHoverStyle(background: string, color?: string): CSSProperties {
  return {
    ["--brand-button-hover-bg" as string]: background,
    ["--brand-button-hover-color" as string]: color ?? "inherit",
  };
}

/** Explicit L1 colors, shared hover/focus behavior, and Mantine's native disabled/loading states. */
export function brandedButtonProps(background: string, hover: string, color: string, hoverColor = color) {
  return {
    autoContrast: false,
    className: brandButtonHoverClassName,
    style: brandButtonHoverStyle(hover, hoverColor),
    styles: { root: { backgroundColor: background, color, borderColor: background } },
  };
}

type ProfileSaveButtonProps = {
  radius: "xl";
  autoContrast: false;
  className: string;
  style: CSSProperties;
  styles: {
    root: {
      backgroundColor: string;
      color: string;
      borderColor: string;
    };
  };
};

/** Edit profile save button; disabled state keeps Mantine fill, grey border only (`.profileSaveButton`). */
export function profileSaveButtonProps(): ProfileSaveButtonProps {
  const background = brandColorTokens.profileSaveButton;
  const hover = brandColorTokens.profileSaveButtonHover;
  const color = brandColorTokens.profileSaveButtonText;

  return {
    radius: "xl" as const,
    autoContrast: false,
    className: `${brandButtonHoverClassName} ${classes.profileSaveButton}`,
    style: {
      ...brandButtonHoverStyle(hover, color),
      ["--profile-save-button-disabled-border" as string]: brandColorTokens.profileFieldDisabledBorder,
    },
    styles: {
      root: {
        backgroundColor: background,
        color,
        borderColor: background,
      },
    },
  };
}

export const brandSelectDropdownClassNames = {
  dropdown: selectClasses.facilitatorSelectDropdown,
  option: selectClasses.facilitatorSelectOption,
} as const;
export function brandSelectDropdownStyle(): CSSProperties {
  return {
    ["--facilitator-list-option-hover-bg" as string]: brandColorTokens.facilitatorListOptionHover,
    ["--facilitator-list-option-selected-bg" as string]: brandColorTokens.facilitatorListOptionSelected,
    ["--facilitator-list-option-selected-color" as string]: brandColorTokens.facilitatorListOptionSelectedText,
  };
}
export const brandSelectDropdownStyles = { dropdown: brandSelectDropdownStyle() } as const;
